import { ar } from "./arabic";
import { en } from "./english";
const localization = {
  en,
  ar,
};

export default localization;
